module.exports = __webpack_public_path__ + "img/two2.89ee4e58.png";